<form [formGroup]="parentFormGroup">
  <mat-form-field class="app-selector">
    <mat-select [formControlName]="controlName" [placeholder]="placeholderText">
      <mat-option>
        <ngx-mat-select-search [formControl]="appFilterControl" placeholderLabel="Please start typing"
        noEntriesFoundLabel="No Apps found" [searching]="searching()"></ngx-mat-select-search>
      </mat-option>
      @for (app of filteredApps | async; track app.id) {
        <mat-option [value]="app.id">
          {{app.name}}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
</form>
